import { Color } from '../entities/Color';
import { ComponentKewlox } from './ComponentKewlox';
import { DrawersEntity, SearchInfo } from '../Data';
import { DataStorage, getColors } from '../utils/dataStorage';
import {
  MINIMUM_WIDTH_FOR_TWO_DRAWER_HANDLES,
  Position,
  PositionAngle,
  STANDARD_COLOR,
} from '../constants';
import { CustomPiece } from './CustomPiece';
import { DrawerHandle } from './DrawerHandle';
import { findColor } from '../utils/colorHelper';

export class Drawer extends ComponentKewlox {
  readonly width: number;
  readonly depth: number;
  readonly color: Color;

  static _lookup = ['height', 'width', 'depth'];

  constructor(
    id: number,
    name: string,
    reference: string,
    price: number,
    weigth: number,
    forSale: boolean,
    visible: boolean,
    height: number,
    width: number,
    depth: number,
    color: Color,
  ) {
    super(id, name, reference, price, weigth, forSale, visible, height);
    this.width = width;
    this.depth = depth;
    this.color = color;
  }

  get typeComponent() {
    return 'Drawer';
  }

  static fromJSON(json: DrawersEntity): Drawer {
    let objColor: Color;
    if (typeof json.color === 'number') {
      const colors = getColors();
      objColor = colors[0];
      for (const colorItem of colors) {
        if (colorItem.id === json.color) {
          objColor = colorItem;
        }
      }
    } else {
      objColor = json.color as Color;
    }

    const o = Object.create(Drawer.prototype);
    return Object.assign(o, this, json, {
      color: objColor,
    });
  }

  static reviver(key: string, value: any): any {
    return key === '' ? Drawer.fromJSON(value) : value;
  }

  compareTo(otherComponent: ComponentKewlox): number {
    return (
      this.height - otherComponent.height ||
      this.width - (otherComponent as Drawer).width ||
      this.depth - (otherComponent as Drawer).depth
    );
  }

  includeInto(otherComponent: ComponentKewlox): boolean {
    return (
      this.height - otherComponent.height >= 0 &&
      this.width - (otherComponent as Drawer).width >= 0 &&
      this.depth - (otherComponent as Drawer).depth >= 0
    );
  }

  static getSearchInfos(
    height: number,
    width: number,
    depth: number,
    color: Color,
  ): SearchInfo {
    return {
      lookup: this._lookup,
      key: { height, width, depth, color: color.id },
    };
  }

  getKey(): string {
    return Drawer.generateKey(this.height, this.width, this.depth, this.color);
  }

  static generateKey(
    height: number,
    width: number,
    depth: number,
    color: Color,
  ) {
    const searchInfos = Drawer.getSearchInfos(height, width, depth, color);
    return JSON.stringify(searchInfos.key);
  }

  static standardDrawer(
    height: number,
    width: number,
    depth: number,
    position: number,
  ): CustomPiece<Drawer> {
    /**
     * Return a standard Door as custom piece
     */
    const color = findColor(STANDARD_COLOR);
    const pieces = DataStorage.pieces;
    const searchInfo = Drawer.getSearchInfos(
      height,
      width,
      depth,
      color as Color,
    );
    const standardDrawer = pieces.drawers.getCustom(searchInfo, position, true);

    if (standardDrawer.width >= MINIMUM_WIDTH_FOR_TWO_DRAWER_HANDLES) {
      const hDLeft = DrawerHandle.standardHandle(PositionAngle.FrontLeft);
      const hDRight = DrawerHandle.standardHandle(PositionAngle.FrontRight);
      standardDrawer.handle = [hDLeft, hDRight];
    } else {
      standardDrawer.handle = [DrawerHandle.standardHandle(Position.Front)];
    }
    return standardDrawer;
  }
}
